window.ConnectionInstanceMonitor = {
    lastState: null,
    initialized: false,
    intervalId: null,
    authToken: null,
    currentInstanceId: null,

    start(instanceId, authToken, container) {
        const frame = document.getElementById("qr_code_container");
        if (!instanceId || !frame || !authToken) return;

        if (this.intervalId && this.currentInstanceId === instanceId) {
            console.log("⏳ Monitor já ativo para esta instância, ignorando novo start...");
            return;
        }

        this.stop(); // para outros que estejam rodando

        this.authToken = authToken;
        this.initialized = false;
        this.lastState = null;
        this.currentInstanceId = instanceId;

        this.intervalId = setInterval(() => {
            fetch(`/whats/v1/instances/instance_connect_status`, {
                headers: {
                    "Authorization": this.authToken
                }
            })
                .then(res => res.json())
                .then(data => {
                    const newState = data.data?.instance?.state;
                    if (!newState) return;

                    if (!this.initialized) {
                        this.lastState = newState;
                        this.initialized = true;
                        return;
                    }

                    if (newState !== this.lastState && ["open", "close"].includes(newState)) {
                        this.lastState = newState;
                        console.log(`🔄 Status mudou para '${newState}' — atualizando widget`);

                        fetch(`/polemk_instances/${instanceId}/broadcast_connection`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                                "Authorization": this.authToken
                            },
                            body: JSON.stringify({ status: newState })
                        }).then(() => {
                            if (container?.getData()) {
                                container.getData().silent = true;
                                container.getProxy().execute();
                            }
                        });
                    } else {
                        this.lastState = newState;
                    }
                });
        }, 10000);
    },

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            console.log("🛑 Monitor de conexão parado");
            this.intervalId = null;
            this.currentInstanceId = null;
        }
    }
};
